<template>
  <div class="content">
    <van-tabs v-model="active" @change="handleTab">
      <van-tab title="国内">
        <div class="contentBox">
          <div class="searchBox">
            <van-search
              v-model="searchVal"
              placeholder="搜索地点名称"
              @focus="onFocus"
              @search="onSearch"
              @input="onInput"
            >
              <template #left-icon>
                <i style="color: #a4a9bf" class="iconfont icon-search_s"></i>
              </template>
            </van-search>
            <span
              v-if="flag"
              class="text-span"
              @click="(flag = false), (searchVal = '')"
              >返回</span
            >
          </div>
          <div class="textSearch" v-if="flag">
            <div style="margin: 15px 0" class="title">搜索结果</div>
            <div
              class="text"
              v-for="(item, index) in searchList"
              :key="index"
              @click="placeNameCheckbox(item)"
              :class="item.flag == true ? 'checked' : 'checkbox'"
            >
              <van-icon v-if="item.flag" class="checkIcon" name="success" />{{
                item.name
              }}
            </div>
          </div>
          <div v-else class="textBox">
            <div v-if="placeSelected.length > 0">
              <div style="margin: 15px 0" class="title">已选</div>
              <div
                class="text checked"
                v-for="(item, index) in placeSelected"
                :key="index"
                @click="placeNameCheckbox(item)"
              >
                <van-icon v-if="item.flag" class="checkIcon" name="success" />{{
                  item.name
                }}
              </div>
            </div>
            <div>
              <div style="margin: 15px 0" class="title">地点</div>
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text=""
                  :immediate-check="false"
                  @load="onLoad"
                >
                  <div
                    class="text"
                    v-for="(item, index) in placeList"
                    :key="index"
                    @click="placeNameCheckbox(item)"
                    :class="item.flag == true ? 'checked' : 'checkbox'"
                  >
                    <i v-if="item.flag" class="iconfont icon-duigou"></i>
                    {{ item.name }}
                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
          </div>
        </div>
        <div class="btn">
          <van-button type="default" block @click="placeReset()" class="reset"
            >重置</van-button
          ><van-button type="primary" block class="determine" @click="success()"
            >确定</van-button
          >
        </div>
        <div class="bottom"></div>
      </van-tab>
      <van-tab title="国外">
        <div class="contentBox">
          <div class="searchBox">
            <van-search
              v-model="searchVal"
              placeholder="搜索药物名称"
              @focus="onFocus"
              @search="onSearch"
              @input="onInput"
            >
            </van-search>
            <span
              v-if="flag"
              class="text-span"
              @click="(flag = false), (searchVal = '')"
              >返回</span
            >
          </div>
          <div class="textSearch" v-if="flag">
            <div style="margin: 15px 0" class="title">搜索结果</div>
            <div
              class="text"
              v-for="(item, index) in searchList_abroad"
              :key="index"
              @click="placeNameCheckbox(item)"
              :class="item.flag == true ? 'checked' : 'checkbox'"
            >
              <van-icon v-if="item.flag" class="checkIcon" name="success" />{{
                item.name
              }}
            </div>
          </div>
          <div v-else class="textBox">
            <div v-if="placeSelected.length > 0">
              <div style="margin: 15px 0" class="title">已选</div>
              <div
                class="text checked"
                v-for="(item, index) in placeSelected"
                :key="index"
                @click="placeNameCheckbox(item)"
              >
                <van-icon v-if="item.flag" class="checkIcon" name="success" />{{
                  item.name
                }}
              </div>
            </div>
            <div>
              <div style="margin: 15px 0" class="title">地点</div>
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text=""
                  :immediate-check="false"
                  @load="onLoad"
                >
                  <div
                    class="text"
                    v-for="(item, index) in placeList_abroad"
                    :key="index"
                    @click="placeNameCheckbox(item)"
                    :class="item.flag == true ? 'checked' : 'checkbox'"
                  >
                    <i v-if="item.flag" class="iconfont icon-duigou"></i>
                    {{ item.name }}
                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
          </div>
        </div>
        <div class="btn">
          <van-button type="default" block @click="placeReset()" class="reset"
            >重置</van-button
          ><van-button type="primary" block class="determine" @click="success()"
            >确定</van-button
          >
        </div>
        <div class="bottom"></div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { FindByList } from "@/api/wxapi.js";

export default {
  data() {
    return {
      active: 0,
      placeSelected: [],
      searchVal: "",
      flag: false,
      loading: false,
      finished: false,
      refreshing: false,
      placeList: [],
      placeList_abroad: [],
      searchList: [],
      searchList_abroad: [],
      pageNo: 1,
      total: 0,
    };
  },
  mounted() {
    this.getplaceList();
    this.getplaceList_abroad();
  },
  methods: {
    clear() {
      this.placeSelected = [];
      this.placeList.forEach((item) => {
        item.flag = false;
      });
      this.placeList_abroad.forEach((item) => {
        item.flag = false;
      });
    },
    handleTab(val) {
      this.placeSelected = [];
      if (val == 0) {
        this.placeList.forEach((item) => {
          item.flag = false;
        });
      } else {
        this.placeList_abroad.forEach((item) => {
          item.flag = false;
        });
      }
    },
    placeReset() {
      this.placeSelected = [];

      if (this.active == 0) {
        this.placeList.forEach((item) => {
          item.flag = false;
        });
      } else {
        this.placeList_abroad.forEach((item) => {
          item.flag = false;
        });
      }
    },
    onFocus() {
      this.flag = true;

      if (this.active == 0) {
        this.placeSelected = [];
        this.placeList.forEach((item) => {
          item.flag = false;
        });
      } else {
        this.placeSelected = [];
        this.placeList_abroad.forEach((item) => {
          item.flag = false;
        });
      }
    },
    success() {
      let placeArr = [];
      if (this.placeSelected.length > 0) {
        this.placeSelected.forEach((item) => {
          placeArr.push(item.name);
        });
        this.$emit("child", placeArr);
      } else {
        this.$emit("child", placeArr);
      }
      console.log(this.placeSelected);
    },
    onSearch(val) {
      this.searchVal = val;

      if (this.active == 0) {
        this.getSearch();
      } else {
        this.getSearch_abroad();
      }
    },
    onInput(val) {
      this.searchVal = val;
      if (this.active == 0) {
        this.getSearch();
      } else {
        this.getSearch_abroad();
      }
    },
    onLoad() {
      if (this.active == 0) {
        this.pageNo++;
        this.getplaceList();
      } else {
        this.pageNo++;
        this.getplaceList_abroad();
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.refreshing = true;
      if (this.active == 0) {
        this.getplaceList();
      } else {
        this.getplaceList_abroad();
      }
    },
    placeNameCheckbox(item) {
      item.flag = !item.flag;
      this.placeSelected = [];
      if (this.active == 0) {
        if (this.flag) {
          console.log(this.placeSelected);
          this.searchList.forEach((item) => {
            if (item.flag) {
              this.placeSelected.push(item);
            }
          });
        } else {
          this.placeList.forEach((item) => {
            if (item.flag) {
              this.placeSelected.push(item);
            }
          });
        }
      } else {
        if (this.flag) {
          console.log(this.placeSelected);
          this.searchList_abroad.forEach((item) => {
            if (item.flag) {
              this.placeSelected.push(item);
            }
          });
        } else {
          this.placeList_abroad.forEach((item) => {
            if (item.flag) {
              this.placeSelected.push(item);
            }
          });
        }
      }
    },
    // 国外
    getSearch_abroad() {
      FindByList({
        locations: this.searchVal, //药物
        clinicalTag: "site",
        pageNo: 1,
        pageSize: 99999,
        site: 1,
      }).then((res) => {
        var rows = [];
        res.data.records.forEach((item) => {
          let obj = {
            name: item,
            id: +new Date(),
            flag: false,
          };
          rows.push(obj);
        });
        this.searchList_abroad = rows;
      });
    },
    getplaceList_abroad() {
      FindByList({
        // place: this.searchVal, //药物
        // locations: this.locationsVal, // 地点
        // phasesEn: this.phasesEnVal, //分期
        // tissueCh: this.cancerNameSearch, //适应症
        clinicalTag: "site",
        pageNo: this.pageNo,
        pageSize: 10,
        site: 1,
      }).then((res) => {
        var rows = [];
        res.data.records.forEach((item) => {
          let obj = {
            name: item,
            id: +new Date(),
            flag: false,
          };
          rows.push(obj);
        });
        console.log(rows, "rows");
        this.loading = false;
        this.refreshing = false;

        this.total = res.data.total;
        if (rows == null || rows.lenght === 0) {
          this.finished = true;
          return;
        }
        this.placeList_abroad = this.placeList_abroad.concat(rows);
        // this.placeChoose = [...this.placeChoose, ...rows];

        if (this.placeList_abroad.length >= this.total) {
          this.finished = true;
        }
      });
    },
    // 国内
    getSearch() {
      FindByList({
        locations: this.searchVal, //药物
        clinicalTag: "site",
        pageNo: 1,
        pageSize: 99999,
        site: 0,
      }).then((res) => {
        var rows = [];
        res.data.records.forEach((item) => {
          let obj = {
            name: item,
            id: +new Date(),
            flag: false,
          };
          rows.push(obj);
        });
        this.searchList = rows;
      });
    },
    getplaceList() {
      FindByList({
        // place: this.searchVal, //药物
        // locations: this.locationsVal, // 地点
        // phasesEn: this.phasesEnVal, //分期
        // tissueCh: this.cancerNameSearch, //适应症
        clinicalTag: "site",
        pageNo: this.pageNo,
        pageSize: 10,
        site: 0,
      }).then((res) => {
        var rows = [];
        res.data.records.forEach((item) => {
          let obj = {
            name: item,
            id: +new Date(),
            flag: false,
          };
          rows.push(obj);
        });
        console.log(rows, "rows");
        this.loading = false;
        this.refreshing = false;

        this.total = res.data.total;
        if (rows == null || rows.lenght === 0) {
          this.finished = true;
          return;
        }
        this.placeList = this.placeList.concat(rows);
        // this.placeChoose = [...this.placeChoose, ...rows];

        if (this.placeList.length >= this.total) {
          this.finished = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-field__control {
  color: #a4a9bf !important;
}
.contentBox {
  box-sizing: border-box;
  .checked {
    color: #4b84ff !important;
    i {
      font-size: 13px;
      color: #4b84ff;
      margin-right: 6px;
    }
  }
  /deep/.searchBox {
    width: 100%;
    height: 36px;
    margin: 10px 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text-span {
      min-width: 40px;
      margin-left: 10px;
      text-align: center;
    }
    .van-search {
      width: 100%;
    }
    .van-search__content {
      border-radius: 18px;
      border: 1px solid #e3e5e8;
      background: none;
    }
    .van-field__control {
      font-size: 12px;
      font-weight: 400;
      color: #a4a9bf;
    }
  }
  .textBox,
  .textSearch {
    width: 100%;
    height: 445px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    .title {
      //   width: 31px;
      height: 22px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #2f354d;
    }
    .text {
      margin-bottom: 22px;
      color: #2f354d;
      font-size: 13px;
      font-weight: 400;
      color: #2f354d;
      display: flex;
      align-items: center;
      word-wrap: break-word;
      word-break: break-all;
    }
  }
}
.content {
  position: relative;
  width: 100%;
  //   height: 100%;
  padding: 40px 24px;
  //   background: #000;
  .btn {
    position: fixed;
    left: 0;
    bottom: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    box-sizing: border-box;

    //  background: #000;
    .reset {
      width: 101px;
      height: 44px;
      margin-right: 12px;
      box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.15);
      border-radius: 22px;
      border: 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
    }
    .determine {
      width: 214px;
      height: 44px;
      background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
      box-shadow: 0px 6px 20px -2px rgba(75, 132, 255, 0.3);
      border-radius: 22px;
      border: 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .bottom {
    height: 34px;
    position: absolute;
    left: 0;
    bottom: 0px;
  }
}
</style>